import { defineComponent, ref, useFetch, watch, computed } from "@nuxtjs/composition-api";
import spriteIcons from "../spriteIcons";
import { useIconCache } from "../composables/useIconCache";
import iconPath from "~/assets/wm-icon-sprite/sprite.svg";
const __vue_script__ = defineComponent({
  name: "WmIcon",
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: ""
    },
    width: {
      type: String,
      default: "1em"
    },
    height: {
      type: String,
      default: "1em"
    }
  },
  setup(props) {
    const { loadIcon } = useIconCache();
    const iconLoaded = ref(false);
    const isSprite = computed(() => spriteIcons.includes(props.name));
    const iconAttributes = ref({});
    const iconBody = ref("");
    const { fetch } = useFetch(async () => {
      if (isSprite.value) {
        iconAttributes.value = {
          width: props.width,
          height: props.height
        };
        let iconUrl = "";
        if (typeof iconPath === "string") {
          iconUrl = iconPath;
        } else if (typeof iconPath === "object" && typeof iconPath.default === "string") {
          iconUrl = iconPath.default;
        }
        const body = `<use href="${iconUrl + "#i-" + props.name}" xlink:href="${iconUrl + "#i-" + props.name}" />`;
        iconBody.value = props.label ? "<title>" + props.label + "</title>" + body : body;
        iconLoaded.value = true;
      } else {
        const icon = await loadIcon(props.name);
        if (icon) {
          let label = "";
          let license = "";
          if (props.label) {
            label = "<title>" + props.label + "</title>";
          }
          if (icon.license) {
            license = icon.license;
          }
          iconAttributes.value = {
            viewBox: `0 0 ${icon.width} ${icon.height}`,
            width: props.width,
            height: props.height
          };
          iconBody.value = label + license + icon.body;
          iconLoaded.value = true;
        }
      }
    });
    watch(() => props.name, async (name) => {
      await fetch();
    });
    return {
      iconAttributes,
      iconBody,
      isSprite,
      iconLoaded
    };
  }
});
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.iconLoaded && _vm.iconAttributes ? _c(
    "svg",
    _vm._b(
      {
        attrs: { xmlns: "http://www.w3.org/2000/svg" },
        domProps: { innerHTML: _vm._s(_vm.iconBody) }
      },
      "svg",
      _vm.iconAttributes,
      false
    )
  ) : _c("svg", {
    attrs: {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      width: _vm.width,
      height: _vm.height
    }
  });
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;
const __vue_inject_styles__ = void 0;
const __vue_scope_id__ = void 0;
const __vue_module_identifier__ = void 0;
const __vue_is_functional_template__ = false;
function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  const component = (typeof script === "function" ? script.options : script) || {};
  component.__file = "src/runtime/components/WmIcon.vue";
  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional)
      component.functional = true;
  }
  component._scopeId = scope;
  if (false) {
    let hook;
    if (false) {
      hook = function(context) {
        context = context || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
        if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
          context = __VUE_SSR_CONTEXT__;
        }
        if (style) {
          style.call(this, createInjectorSSR(context));
        }
        if (context && context._registeredComponents) {
          context._registeredComponents.add(moduleIdentifier);
        }
      };
      component._ssrRegister = hook;
    } else if (style) {
      hook = shadowMode ? function(context) {
        style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
      } : function(context) {
        style.call(this, createInjector(context));
      };
    }
    if (hook !== void 0) {
      if (component.functional) {
        const originalRender = component.render;
        component.render = function renderWithStyleInjection(h, context) {
          hook.call(context);
          return originalRender(h, context);
        };
      } else {
        const existing = component.beforeCreate;
        component.beforeCreate = existing ? [].concat(existing, hook) : [hook];
      }
    }
  }
  return component;
}
const __vue_component__ = /* @__PURE__ */ __vue_normalize__(
  { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
  __vue_inject_styles__,
  __vue_script__,
  __vue_scope_id__,
  __vue_is_functional_template__,
  __vue_module_identifier__,
  false,
  void 0,
  void 0,
  void 0
);
var WmIcon_default = __vue_component__;
export {
  WmIcon_default as default
};
